<div class="mat-dialog-container-in">
  <div class="dialog-box create-dialog-box {{custom_dialog_box}}" id="sensor-errors-box">
    <div *ngIf="icon_class" class="dialog-icon {{icon_class}} {{marRight}}"></div>
    <div class="dialog-content">
      <h1 *ngIf="!warningDialog" mat-dialog-title [ngClass]="{'small_text':small_font}">{{text}}</h1>
      <div *ngIf="warningDialog" mat-dialog-content>
        <div  class="mat-dialog-content scrolled" [innerHtml]="warningDialog"></div>
      </div>
      <div [ngClass]="dialog_button_box">
        <button class="reset-but" mat-dialog-close >OK</button>
        <button *ngIf="routerlink != null && has_priv" mat-dialog-close="to_sensors" [routerLink] = [routerlink] [ngClass]="ng_class">{{ routerLinkText }}</button>
        </div>
    </div>
  </div>
</div>

